<template>
  <div>    
    <main-content right-sidebar="true">
      <transition-group
        @before-enter="beforeEnter"
        @enter="enter"
        @afterEnter="afterEnter"
        @beforeLeave="beforeLeave"
        @leave="leave"
        @afterLeave="afterLeave"
        class="tag-wrapper"
      >
        <div
          v-for="(livingOption, index) in activeLivingOptions"
          :key="livingOption._id"
          :data-index="index"
          @click="openSubsection(livingOption._id)"
        >
          <tag-basic
            v-if="!livingOption.isVisuallyHidden"
            v-bind="livingOption.marker"
            :pos="{ 
              x: livingOption.marker.x,
              y: livingOption.marker.y
            }"
            :show-sold-label="showSoldLabel(livingOption)"
            :label="{ en: isSoldOut(livingOption) ? livingOption.label : livingOption.label + '<br>now selling' }"
            :style="`transform: rotate(${livingOption.marker.rotation}deg);`"
          />

          <polygon-shape
            v-if="livingOption.polygon && livingOption.polygon.points.length && !livingOption.isVisuallyHidden"
            :polygon="livingOption.polygon"
            :to="polygonUrl(livingOption._id)"
          />
        </div>
      </transition-group>
    </main-content>
  </div>
</template>
<script>
import MainContent from '@/components/MainContent'
import PolygonShape from '@/components/PolygonShape'
import TagBasic from '@/components/TagBasic'
import { bus } from '../main'

export default {
  props: ['living-options'],

  components: { MainContent, PolygonShape, TagBasic },

  data () {
    return {
      activeLivingOptions: []
    }
  },

  computed: {
    categoryId () {
      return this.$route.params.categoryId
    },

    pathway () {
      return this.$route.params.pathway
    },

    styleTemplate () {
      return this.$store.state.styleTemplate
    }
  },

  watch: {
    livingOptions (newLivingOptions, oldLivingOptions) {
      if (!_.isEqual(oldLivingOptions, newLivingOptions)) {
        if (oldLivingOptions.length) {
          this.activeLivingOptions = []
        }

        if (newLivingOptions.length) {
          this.$store.commit('addAnimationToQueue', 'LivingOptionTags')
        }
      }
    }
  },

  mounted () {
    bus.$on('animateLivingOptionTags', () => {
      if (!_.isEqual(this.activeLivingOptions, this.livingOptions)) {
        this.activeLivingOptions = this.livingOptions
      } else {
        bus.$emit('finishedAnimation')
      }
    })
  },

  methods: {
    isSoldOut (livingOption) {
      return livingOption.availablePropertiesCount === 0
    },
    
    showSoldLabel (livingOption) {
      return this.styleTemplate['general']['show-sold-label'] && this.isSoldOut(livingOption)
    },

    openSubsection (id) {
      // do the route calc
      const categoryId = this.$route.params.categoryId
      const pathway = this.$route.params.pathway

      const toLivingOption = this.$store.getters['property/livingOptions'].find(livingOption => livingOption._id === id)

      const isSoldOut = toLivingOption.availablePropertiesCount === 0
      const canInteract = this.styleTemplate['general']['can-interact-sold-livingoptions']

      if (isSoldOut && !canInteract) {
        return
      }

      if (toLivingOption.subsections.length === 1) {
        this.$router.push(`/category/${this.categoryId}/live/${this.pathway}/${id}/subsection/${toLivingOption.subsections[0]._id}?activeSubsectionId=${toLivingOption.subsections[0]._id}`)
      } else {
        this.$router.push(`/category/${this.categoryId}/live/${this.pathway}/${id}`)
      }
    },

    polygonUrl (id) {
      // do the route calc
      const categoryId = this.$route.params.categoryId
      const pathway = this.$route.params.pathway

      const toLivingOption = this.$store.getters['property/livingOptions'].find(livingOption => livingOption._id === id)

      if (toLivingOption.subsections.length === 1) {
        return `/category/${this.categoryId}/live/${this.pathway}/${id}/subsection/${toLivingOption.subsections[0]._id}?activeSubsectionId=${toLivingOption.subsections[0]._id}`
      } else {
        return `/category/${this.categoryId}/live/${this.pathway}/${id}`
      }
    },

    beforeEnter (el) {
      el.removeAttribute('style')
      el.style.opacity = 0
      el.style.transform = 'translateY(25%)'
    },

    enter (el, done) {
      setTimeout(() => {
        el.style.opacity = 1
        el.style.transform = 'translateY(0)'
        el.style.transition = `transform 0.6s cubic-bezier(0.33, 1, 0.68, 1), opacity 1.2s`
        setTimeout(() => {
          done()
        }, 300)
      }, (parseInt(el.dataset.index) + 1) * 150)
    },

    afterEnter (el) {
      if (parseInt(el.dataset.index) + 1 === this.livingOptions.length) {
        bus.$emit('finishedAnimation')
      }      
      el.removeAttribute('style')
    },

    beforeLeave (el) {
      el.style.transition = `transform 0.3s cubic-bezier(0.32, 0, 0.67, 0), opacity 0.3s`
    },

    leave (el) {
      el.style.opacity = 0
      el.style.transform = 'translateY(25%)'
    },

    afterLeave (el) {
      el.removeAttribute('style')
    }
  }
}
</script>
<style lang="scss" scoped>
.tag-wrapper {
  position: absolute;
  top: 0;
  left: 0;

  .layout-switched & {
    top: 10rem;
  }
}
</style>
